import { LoginService } from './../../../service/login.service';

import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-siderbar',
  templateUrl: './siderbar.component.html',
  styleUrls: ['./siderbar.component.scss']
})
export class SiderbarComponent implements OnInit {

name:any;
  constructor(private route:Router,
    private apiService:LoginService) {
      this.name={name:"",image:{url:'https://cdn.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png'},email:''}
     }

  ngOnInit(): void {
    this.getProfie();
  }

getProfie()
{
      const id=localStorage.getItem('LoginId');
  this.apiService.getProfile(id).then(
    (res:any)=>
    {
      this.name=res;
      console.log(this.name);
    }
  );
 
}

}
